import React from "react";
import { Row, Col } from "react-bootstrap";

import { HookFormDatePickerCommon } from "components";

import BillingStatusField from "./billingStatusField";

type AchPaymentSectionProps = {
	isLoading: boolean;
	sectionName: string;
	index: number;
	defaultValue: { [key: string]: any };
};

const AchPaymentSection = ({
	isLoading,
	sectionName,
	index,
	defaultValue,
}: AchPaymentSectionProps) => {
	return (
		<>
			<BillingStatusField
				isLoading={isLoading}
				sectionName={sectionName}
				index={index}
				defaultValue={defaultValue}
			/>
			<Row className="form-group">
				<Col md={5}>
					<HookFormDatePickerCommon
						label="Invoice Date"
						name={`${sectionName}.${index}.paymentTypeInfo.invoiceDate`}
						isLoading={isLoading}
						defaultValue={defaultValue?.invoiceDate}
						maxDate={new Date()}
					/>
				</Col>
				<Col md={{ offset: 2, span: 5 }}>
					<HookFormDatePickerCommon
						label="Payment Date"
						name={`${sectionName}.${index}.paymentTypeInfo.paymentDate`}
						isLoading={isLoading}
						defaultValue={defaultValue?.paymentDate}
						maxDate={new Date()}
					/>
				</Col>
			</Row>
		</>
	);
};

export default AchPaymentSection;
